/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";

/* Helpers, constants, custom methods, internal libraries */
import {usePolicyService} from "../../../services/policyService";
import {useUserContext} from "../../../contexts/userContext";
import { EDIT_POLICY_ROUTE } from "../../../constants/routes";

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as CreatePolicySvg } from '../../../resources/images/aa-create-policy.svg';
import { useGlobalContext } from "../../../contexts/globalContext";
import { useGlobalUpdateContext } from "../../../contexts/globalContext";

/* Styles */
import styles from "./styles";

const CreatePolicyModal = ({showCreatePolicyModal, setShowCreatePolicyModal}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const [policyNameError, setPolicyNameError] = useState(false);
  const [genericError, setGenericError] = useState(false);
  const navigate = useNavigate();
  const globalProperties  = useGlobalContext();
  const setGlobalProperties  = useGlobalUpdateContext();

  const { createPolicy } = usePolicyService({
    onError() {
      setGenericError(true)
    },
  });
  const userDetails = useUserContext();

  const companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId

  const handleCreatePolicy = async (values) => {
    const response = await createPolicy(values)
    if ((response.statusCode === "ERROR" || response.errors) && response?.errors[0]?.errorCode === '8000') {
      setPolicyNameError(true)
    } else if (response) {
      setGlobalProperties({
        ...globalProperties,
        addFirstPolicyData: {
          ...globalProperties.addFirstPolicyData,
          firstTimeSaved: true
        }
      })
      setShowCreatePolicyModal(false)
      navigate(
        "../" + EDIT_POLICY_ROUTE.replace(":policyId", response.policyId),
        {
          state: {
            policyId: response.policyId,
            policyName: response.policyName,
            showSaveBtn: true,
          }
        }
      );
    }
  }

  const resetErrorMessages = () => {
    setPolicyNameError(false)
    setGenericError(false)
  }

  return (
      <UCModal
        className={classes.createPolicyModal}
        showModal={ showCreatePolicyModal }
        setShowModal={ setShowCreatePolicyModal }
        modalIcon={ <CreatePolicySvg /> }
        modalTitle={ <FormattedMessage id="createPolicy.title"/> }
        modalDescription={ <FormattedMessage id="createPolicy.description"/> }
        modalContent={ 
          <Content 
            setShowModal={setShowCreatePolicyModal} 
            handleCreatePolicy={handleCreatePolicy} 
            companyEntityId={companyEntityId} 
            policyNameError={policyNameError}
            genericError={genericError}
            resetErrorMessages={resetErrorMessages}
          /> 
        }
        dataTestId="createPolicyModal"
        onExited={() => resetErrorMessages()}
      />
  )
}

export default CreatePolicyModal;
